import { point } from '../../elements/point';
import { Rectangle, rectangle } from '../../elements/rectangle';
import { wrapInSvgTag } from '../../svg/wrapInSvgTag';
import { isNonNullable } from '../../types/isNonNullable';
import type { GraphExportData } from './GraphExportData';
import { renderBoxes } from './renderBoxes';
import { renderEdges } from './renderEdges';
import { renderNodes } from './renderNodes';

const VIEWBOX_PADDING = 5;

export const renderGraphSvg = (graph: GraphExportData): string => {
  const [nodes, nodesBB] = renderNodes(graph);
  const [edges, edgesBB] = renderEdges(graph);
  const [boxes, boxesBB] = renderBoxes(graph);

  const boundingBoxes = [nodesBB, edgesBB, boxesBB].filter(isNonNullable);
  const boundingBox =
    boundingBoxes.length > 0
      ? rectangle.mergeBoundingBoxes(...boundingBoxes)
      : // just return empty svg for empty graph
        new Rectangle(point.create(0, 0), 0, 0);
  const viewBox = rectangle.resizeFromCenter(boundingBox, VIEWBOX_PADDING);

  return wrapInSvgTag(`${edges}${nodes}${boxes}`, {
    height: viewBox.height,
    viewBox: `${viewBox.minX} ${viewBox.minY} ${viewBox.width} ${viewBox.height}`,
    width: viewBox.width,
  });
};
